// T-15 — helpers puros de la página Observatory (sobre nosotros).
//
// `Observatory.tsx` filtra miembros del equipo por rol y extrae la URL del
// primer attachment. Son lógica repetida y pura, extraída a este módulo para
// poder testearla sin renderizar la página.

export type Attachment = { url: string }

/** URL del primer attachment, o `''` si no hay ninguno. */
export function getFirstAttachmentUrl(attachments: Attachment[] | undefined): string {
  return attachments && attachments.length ? attachments[0].url : ''
}

/** Filtra miembros por rol. Con `{ exclude: true }` devuelve los que NO tienen
 *  ese rol (la pestaña "Equipo" excluye a los roles `comite`). */
export function getTeammembersByRole<T extends { role: string }>(
  members: T[],
  role: string,
  opts: { exclude?: boolean } = {},
): T[] {
  const { exclude = false } = opts
  return members.filter(member => (exclude ? member.role !== role : member.role === role))
}